import React, { FC, useState } from 'react'
import { Button, Table, Input, message, Upload } from 'antd'
import { YhBox } from '@/components/YhBox'
import { ColumnsType } from 'antd/es/table'
import { RouterParamType } from '@/model/navModel'
import { EditableRow, EditableCell, Item } from '@/components/YHEditTable/editTable'
import { ISupplierInvoiceInfo } from '../../supplierTypes'
import { useSupplierDetailsMode} from "./supplierDetailsModel"
import { generateUniqueId } from '@/utils/utils'

export const InvoiceInfo: FC<RouterParamType> = ({ id, mode }) => {
    const {editInvoiceInfoList, addInvoiceInfoList, setEditInvoiceInfoList, setAddInvoiceInfoList} = useSupplierDetailsMode()
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
   

    const handleAddContacts = () => {
        let dataSource = mode === "edit" ? editInvoiceInfoList : addInvoiceInfoList
        dataSource.push({id: generateUniqueId()})
        mode === "edit" ? setEditInvoiceInfoList([...dataSource]) : setAddInvoiceInfoList([...dataSource]);
    }

    const handleRemoveContacts = () => {
        let dataSource = mode === "edit" ? editInvoiceInfoList : addInvoiceInfoList
        if (!selectedRowKeys.length) {
            message.warning("请选择你要删除的开票信息");
            return;
        }
        mode === "edit" ?
        setEditInvoiceInfoList(origin => origin.filter(item => selectedRowKeys.indexOf(item.id) < 0)) :
        setAddInvoiceInfoList(origin => origin.filter(item => selectedRowKeys.indexOf(item.id) < 0));

        let newSearchData = dataSource.filter(item => selectedRowKeys.indexOf(item.id) < 0)
        mode === "edit" ? setEditInvoiceInfoList([...newSearchData]) : setAddInvoiceInfoList([...newSearchData]);
        setSelectedRowKeys([]);
        message.success("删除成功");
    }

    const action = (
        <div>
            <Button className="mr-5" type="link" shape="round" onClick={handleAddContacts}>
                新增开票信息
            </Button>
            <Button className="mr-5" type="link" shape="round" onClick={handleRemoveContacts}>
                删除开票信息
            </Button>
        </div>
    )

    const columns = [
        {
            title: '序号',
            width: 40,
            fixed: 'left',
            align: 'center',
            render: (t: any, r: any, i: number) => i + 1,
        },
        {
            title: '公司名称',
            width: 140,
            dataIndex: 'corporateName',
            editable: true
        },
        {
            title: '税号',
            width: 140,
            dataIndex: 'taxId',
            editable: true,
            rules:[{
                pattern: /^[a-zA-Z0-9]*$/,
                message: '只能输入数字和字母!',
            }]
        },
        {
            title: '地址',
            width: 140,
            dataIndex: 'companyAddress',
            editable: true
        },
        {
            title: '电话',
            width: 140,
            dataIndex: 'companyPhone',
            editable: true,
            rules:[{
                pattern: /^[0-9\-]*$/,
                message: '只能输入数字和符号 (-)!',
            },]
        },
        {
            title: '开户银行',
            width: 140,
            dataIndex: 'bankOfDeposit',
            editable: true
        },
        {
            title: '银行账号',
            width: 140,
            dataIndex: 'bankAccount',
            editable: true,
            rules:[{
                pattern: /^[0-9]*$/,
                message: '只能输入数字!',
            }]
        },
    ]

    const newSelectColumns = columns.map((col: any, index) => {
        return {
            ...col,
            onCell: (record: ISupplierInvoiceInfo, rowIndex: number) => {
                return {
                    colIndex: index + 1,
                    rowIndex,
                    record,
                    rules: col?.rules,
                    options: col?.options,
                    editType: col?.editType,
                    editable:  col?.editable,
                    onSelectChange: col?.onSelectChange,
                    onSelectFocus: col?.onSelectFocus,
                    onSelectSearch: col?.onSelectSearch,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: handleSave,
                }
            },
        }
    })

    //内联编辑  
    const handleSave = (row: ISupplierInvoiceInfo) => {
        let dataSource = mode === "edit" ? editInvoiceInfoList : addInvoiceInfoList
        const index = dataSource.findIndex((item) => row.id === item.id);
        const item = dataSource[index];
        dataSource.splice(index, 1, { ...item, ...row });
        mode === "edit" ? setEditInvoiceInfoList([...dataSource]) : setAddInvoiceInfoList([...dataSource]);
    }

    return (
        <YhBox title="" action={action}>
            <Table
                rowKey={(record) => record.id}
                rowClassName="editable-row yh-edit-table-tr"
                rowSelection={{
                    selectedRowKeys: selectedRowKeys, //记录选中
                    onChange: (selectedRowKeys: React.Key[], selectedRows: ISupplierInvoiceInfo[]) => {
                        setSelectedRowKeys(selectedRowKeys as string[])
                    },
                }}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                columns={newSelectColumns as ColumnsType<ISupplierInvoiceInfo>}
                dataSource={ mode === 'edit' ? editInvoiceInfoList : addInvoiceInfoList}
                pagination={false}
                scroll={{ x: 'max-content', y: '400px' }}
            />
        </YhBox>
    )
}
